/* ══ v18: FILE STATE IS SERVER STATE ══════════════════════════════════════════════════════════
   Until v17.6 this file held a dozen banners about the data FILES — the folder sentry, fork and
   sync-conflict sightings, misplaced parts, folder grants, the read-only viewer, the roster built
   from filenames. With one server and one database none of those states can occur, so they are
   gone; what is left is the dispatch that every view already calls, fed by the server's states:
   load failure, a Save that reached the server but could not finish in this tab, colleagues who
   saved while this tab was dirty, and the server being unreachable. */

/* v17.4 W3: the Save reached the server, but this tab could not finish updating itself. */
function _saveCompletionBannerHtml() {
  if (!_saveNeedsReload) return '';
  const at = _saveNeedsReload.savedAt
    ? ` The saved copy carries save time <code>${_escapeHtml(_saveNeedsReload.savedAt)}</code>.`
    : '';
  return `<div class="ov-reconnect ov-stale-view"><span class="ov-reconnect-msg">`
    + `<strong>Your changes were saved, but this tab could not finish updating itself.</strong>`
    + at
    + ` Saving is blocked here because the in-memory state may not match the server. `
    + `Note or export any newer changes made while Save was running, then reload this tab.`
    + `</span></div>`;
}

function _dataFileBannersHtml() {
  return _saveCompletionBannerHtml()
       + _srvLoadFailedBannerHtml()
       + _srvColleaguesBannerHtml()
       + _srvRefreshNoteHtml()
       + _srvUnreachableBannerHtml();
}

/* ══ v11.1 (W2): the ROUTING STRIP — every level that does NOT own the data file ═════
   The PORTFOLIO owns the data file: its folder line, its ℹ full path, its Change /
   Reconnect controls and the six full banners live there and ONLY there (W1). Under v11
   one file IS the whole portfolio, so the file's identity is a portfolio-scoped fact;
   showing it on the programme view was v10.5 inheritance (a programme WAS a file then)
   and implied file-per-programme, the model v11 deleted.
   Every level below shows nothing when healthy and exactly ONE strip when not: one
   sentence, one button, never a control. The button is the existing gotoPortfolio(), so
   a problem is solvable from every level in one click — the requirement that shaped
   this version. */
function _fileAlertBlocked() {
  /* the states on which exportFile refuses — kept in one place so the strip, the
     Save button and the refusal cannot disagree about what "blocked" means. */
  return !_dbLoadOk || !!_saveNeedsReload;
}
function _fileAlertStripHtml() {
  if (document.body.classList.contains('view-portfolio')) return '';   /* it owns the real thing */
  /* The colleagues-saved note relays in FULL form: it is about your VIEW being behind, and it
     carries its own control. */
  let html = _saveCompletionBannerHtml() + _srvColleaguesBannerHtml();
  if (_saveNeedsReload) {
    /* The full, specific banner above owns this state. */
  } else if (_fileAlertBlocked()) {
    html += '<div class="fa-strip fa-red"><span class="fa-msg"><strong>Save is blocked</strong> — the portfolio did not load from the server.</span>'
      + '<button class="ov-btn fa-go" onclick="gotoPortfolio()">Open Portfolio</button></div>';
  }
  return html + _srvRefreshNoteHtml() + _srvUnreachableBannerHtml();
}
/* Refreshed from _updateDataSourceLine (already called on every relevant state change)
   and from each show* view switch, AFTER the body class is set — the portfolio test above
   depends on it. Called DIRECTLY, never behind a `typeof` guard — see _repaintFileState
   for what such a guard cost here. */
function _refreshFileAlerts() {
  const host = document.getElementById('fileAlertStrip');
  if (host) {
    const html = _fileAlertStripHtml();
    _replaceFileStateHtml(host, html);
    host.classList.toggle('has-alert', !!html);
  }
  /* W3 (◆1): the cheapest warning-at-every-level there is — the Save button sits in the
     header on every screen already. Fanned through the existing _allSaveBtns() so both
     buttons get it from ONE place and cannot diverge, exactly as dirty/saving/saved do.
     The other four setters only touch those three classes, so `blocked` survives them. */
  const blocked = _fileAlertBlocked();
  _allSaveBtns().forEach(b => {
    b.classList.toggle('blocked', blocked);
    if (_saveNeedsReload) b.title = 'Save is blocked — reload this tab after the previous Save';
    else if (blocked) b.title = 'Save is blocked — the portfolio did not load from the server';
    else if ((b.title || '').indexOf('Save is blocked') === 0) b.removeAttribute('title');
  });
  renderOverallProgress();
}
/* v11.1: the ONE repaint dispatch for file state. Two places used to enumerate views by
   hand (_checkStaleView and the _fetchSentry callback) and both went half-dead when W1
   moved the banners — the same defect v11 found in the COMPOSITION, recurring in the
   dispatch. The portfolio renders its own full banners; every other level goes through
   the strip. Anything that needs to repaint file state calls THIS, never a view.
   ⚠ It replaces _paintStaleViewBanner, which _checkStaleView referenced behind a
   `typeof … === 'function'` guard while NO definition existed anywhere in the shell — so
   on a project or Focus view the stale-view warning was probed, flagged and painted
   NOWHERE. The guard turned a missing function into silence; that is why it survived v11
   and v11.0.1 unnoticed, and why this one is called WITHOUT a typeof guard. */
function _repaintFileState() {
  if (document.body.classList.contains('view-portfolio')) {
    const host = document.getElementById('portfolioFileState');
    if (host) _replaceFileStateHtml(host, _dataFileBannersHtml());
    else renderPortfolio();
    _refreshFileAlerts();
  }
  else _refreshFileAlerts();
  _repaintLastSavedDates();
}
function _replaceFileStateHtml(host, html) {
  if (host.innerHTML === html) return;
  const retryFocused = host.contains(document.activeElement)
    && document.activeElement.classList.contains('launcher-check');
  host.innerHTML = html;
  if (retryFocused) {
    const retry = host.querySelector('.launcher-check');
    if (retry) retry.focus({ preventScroll: true });
  }
}
